import type { ActionTree } from 'vuex';
import type { IIntegration } from '@signing-page/integrations/types/integration';
import StripeService from '@signing-page/integrations/services/stripe.service';
import type { IIntegrationState } from '@signing-page/integrations/store/integrations.store';
import {
  mutationSetStripeError,
  mutationSetStripe,
  mutationSetAuthorizeNet,
  mutationSetAuthorizeNetError,
} from '@signing-page/integrations/store/integrations.mutations';
import type { IRootState } from '@signing-page/store/store';
import AuthorizeNetService from '@signing-page/integrations/services/authorizenet.service';

export const actionLoadStripe = 'loadStripe';
export const actionLoadStripeFailed = 'loadStripeFailed';
export const actionLoadStripeSuccess = 'loadStripeSuccess';

export const actionLoadAuthorizeNet = 'loadAuthorizeNet';
export const actionLoadAuthorizeNetSuccess = 'loadAuthorizeNetSuccess';
export const actionLoadAuthorizeNetFailed = 'loadAuthorizeNetFailed';

export const actions: ActionTree<IIntegrationState, IRootState> = {
  async [actionLoadStripe]({ dispatch }) {
    try {
      const result: IIntegration = await StripeService.getStripeIntegration();
      dispatch(actionLoadStripeSuccess, result);
    } catch (e) {
      dispatch(actionLoadStripeFailed, e.message);
    }
  },
  [actionLoadStripeSuccess]({ commit }, integration: IIntegration) {
    commit(mutationSetStripeError, '');
    commit(mutationSetStripe, integration);
  },
  [actionLoadStripeFailed]({ commit }, error: string) {
    commit(mutationSetStripeError, error);
  },
  async [actionLoadAuthorizeNet]({ dispatch, rootState }) {
    try {
      const result: IIntegration = await AuthorizeNetService.fetchIntegration(
        rootState.documentId,
        rootState.recipientId,
        rootState.authId
      );
      dispatch(actionLoadAuthorizeNetSuccess, result);
    } catch (e) {
      dispatch(actionLoadAuthorizeNetFailed, e.message);
    }
  },
  [actionLoadAuthorizeNetSuccess]({ commit }, integration: IIntegration) {
    commit(mutationSetAuthorizeNetError, '');
    commit(mutationSetAuthorizeNet, integration);
  },
  [actionLoadAuthorizeNetFailed]({ commit }, error: string) {
    commit(mutationSetAuthorizeNetError, error);
  },
};
